import { defer, Params } from "react-router-dom";

import axiosInstance from "services/axiosInstance";
import {
    StatsResponse,
    CMAddressBook,
    // GetCampaignsResponseItem,
    GetCampaignsListResponse,
    GetCampaignDetailsResponse,
    GetAddressBooksResponseItem,
    GetAddressBookDetailsResponse,
    GetDWHSegmentsListResponse,
    CurrentUserDetails,
    CMAccountResponse,
    DatabasesEmailing,
    UnsubscribersListItem,
    HLROperationListItem
} from "services/apiService";
import axios, { AxiosResponse } from "axios";

const getStatsDataPromise = () =>
    axiosInstance
        .get<StatsResponse>(
            process.env.REACT_APP_API_STATS_GET_DATA_ENDPOINT as string
        )
        .then((response) => response.data);

const getCMAddressBooksPromise = () =>
    axiosInstance
        .get<CMAddressBook[]>(
            process.env.REACT_APP_API_CM_GET_ADDRESS_BOOKS_ENDPOINT as string
        )
        .then((response) => response.data);

// ================================= GET CM ACCOUNT LIST  =================================
const getCMAccountList = () =>
    axiosInstance
        .get<CMAccountResponse>(
            process.env.REACT_APP_API_CM_ACCOUNT_LIST_ENDPOINT as string
        )
        .then((response) => response.data);

// ============================= GET CURRENT USER ===========================================
const getCurrentUser = () =>
    axiosInstance
        .get<CurrentUserDetails>(
            process.env.REACT_APP_API_CURRENT_USER_ENDPOINT as string
        )
        .then((response) => response.data);

const getEmailingDb = () =>
    axiosInstance
        .get<DatabasesEmailing>(
            process.env.REACT_APP_API_STATS_GET_DATABASE_EMAILING_ENDPOINT as string
        )
        .then((response) => response.data);

const getDwhRequests = async () => {
    console.log("--- getDwhRequests ---")
    try {
        return await axiosInstance
            .get<GetDWHSegmentsListResponse>(
                (
                    process.env
                        .REACT_APP_API_DWH_GET_SEGMENT_ENDPOINT as string
                )
            )
            .then((response) => response.data)
    } catch (error) {
        console.error("Error while fetching dwh segments:", error);

        throw error;
    }
};

export const loadCampaignCreationData = () => {
    try {
        return defer({
            data: Promise.all([getStatsDataPromise(), getCMAddressBooksPromise()]),
        });
    } catch (error) {
        console.error(
            "Error while loading campaign creation required data:",
            error
        );

        throw error;
    }
};


// ======================================== LOADING CAMPAIGN ALL LIST =================================
export const loadCampaigns = async () => {
    try {
        console.log("\n \t # Loading campaign home, ...");
        const endpoint = process.env.REACT_APP_API_GET_CAMPAIGNS_ENDPOINT as string;
        
        if (!endpoint) {
            throw new Error('API endpoint is not defined');
        }

        // GET campaigns
        const response: AxiosResponse<GetCampaignsListResponse> = await axiosInstance.get(endpoint);

        if (response.status !== 200) {
            console.log("Fail to fetchin campaign ", response.status)
            throw new Error(`Failed to fetch campaigns. Status: ${response.status}`);
        }

        return response.data;
    } catch (error) {
        console.error("Error fetching campaigns from API:", error);
        throw error;
    }
};


// ======================================= LOAD CAMPAIGN ADDRESS BOOKS ===================================
// export const loadCampaignsAddressBooks = async () => {
//     try {
//         console.log("\n \t # Loadinng campaign loaded :",);
//         return defer({
//             data: Promise.all([loadCampaigns(), getCMAddressBooksPromise()]),
//         });
//     } catch (error) {
//         console.error(
//             "Error while loading campaign creation required data:",
//             error
//         );

//         throw error;
//     }
// }


export const loadCampaignsAddressBooks = async () => {
    try {
        console.log("\n \t # Loadinng campaign loaded :",);
        return defer({
            data: Promise.all([loadCampaigns(), getCMAddressBooksPromise()]),
        });
    } catch (error) {
        console.error(
            "Error while loading campaign creation required data:",
            error
        );

        throw error;
    }
}

export const loadCampaignEditionData = ({ params }: { params: Params }) => {
    try {
        return defer({
            data: Promise.all([
                getStatsDataPromise(),
                getCMAddressBooksPromise(),
                axiosInstance
                    .get<GetCampaignDetailsResponse>(
                        (process.env.REACT_APP_API_GET_CAMPAIGN_ENDPOINT as string).replace(
                            ":campaignId",
                            params.campaignId!
                        )
                    )
                    .then((response) => response.data),
            ]),
        });
    } catch (error) {
        console.error("Error while loading campaign edition required data:", error);

        throw error;
    }
};

// ================================== LOAD CAMPAIGN DATA BY ID =================================
export const loadCampaignById = async ({ params }: { params: Params }) => {
    try {
        console.log("================= loadCampaignByIdAndEmailingDb ============================")
        return await axiosInstance
            .get<GetCampaignDetailsResponse>(
                (process.env.REACT_APP_API_GET_CAMPAIGN_ENDPOINT as string).replace(
                    ":campaignId",
                    params.campaignId!
                )
            )
            .then((response) => response.data);
    } catch (error) {
        console.error(
            `Error while loading campaign with id ${params.campaignId!}:`,
            error
        );

        throw error;
    }
};

export const loadCampaignByIdAndEmailingDb = async ({ params }: { params: Params }) => {
    try {
        console.log('\n \t # loadCampaignByIdAndEmailingDb :', params)
        return defer({
            data: Promise.all(
                [loadCampaignById({ params }),
                getEmailingDb(),
                getDwhRequests()]),
        });
    } catch (error) {
        console.error(
            `Error while loading campaign with id ${params.campaignId!}:`,
            error
        );

        throw error;
    }
};

export const loadAddressBooks = async () => {
    console.log("\n\n--- loadAddressBooks ----")
    try {
        return defer({
            addressBooks: axiosInstance
                .get<GetAddressBooksResponseItem[]>(
                    process.env.REACT_APP_API_CM_GET_ADDRESS_BOOKS_ENDPOINT as string
                )
                .then((response) => response.data),
        });
    } catch (error) {
        console.error("Error while fetching address books:", error);

        throw error;
    }
};

export const loadUnsubscribers = async () => {
    console.log("\n\n--- loadUnsubscribers ----")
    try {
        return defer({
            unsubscribers: axiosInstance
                .get<UnsubscribersListItem[]>(
                    process.env.REACT_APP_API_CM_UNSUBSCRIBERS_ENDPOINT as string
                )
                .then((response) => response.data),
        });
    } catch (error) {
        console.error("Error while fetching unsubscribers:", error);

        throw error;
    }
};

export const loadAddressBookDetails = async ({
    params,
}: {
    params: Params;
}) => {
    console.log("--- loadAddressBookDetails ---")
    try {
        return defer({
            addressBookDetails: axiosInstance
                .get<GetAddressBookDetailsResponse>(
                    (
                        process.env
                            .REACT_APP_API_CM_GET_ADDRESS_BOOK_DETAILS_ENDPOINT as string
                    ).replace(":cmGroupId", params.addressBookId!)
                )
                .then((response) => response.data),
        });
    } catch (error) {
        console.error("Error while fetching address book details:", error);

        throw error;
    }
};

export const loadDwhRequests = async ({
    params,
}: {
    params: Params;
}) => {
    console.log("--- loadDwhRequests ---")
    console.log("endpoint :", process.env
        .REACT_APP_API_DWH_GET_SEGMENT_ENDPOINT as string)
    try {
        return defer({
            dwhSegments: axiosInstance
                .get<GetDWHSegmentsListResponse>(
                    (
                        process.env
                            .REACT_APP_API_DWH_GET_SEGMENT_ENDPOINT as string
                    )
                )
                .then((response) => response.data),

        });

        // return await axiosInstance
        //   .get<GetDWHSegmentsListResponse>(
        //     (
        //       process.env
        //         .REACT_APP_API_DWH_GET_SEGMENT_ENDPOINT as string
        //     )
        //   )
        //   .then((response) => response.data)

    } catch (error) {
        console.error("Error while fetching dwh segments:", error);

        throw error;
    }
};

// a faire 
export const loadStatsCampaing = async () => {
    try {
        console.log("--- loadStatsCampaing ---")
        return defer({
            dwhSegments: axiosInstance
                .get<GetDWHSegmentsListResponse>(
                    (
                        process.env
                            .REACT_APP_API_DWH_GET_SEGMENT_ENDPOINT as string
                    )
                )
                .then((response) => response.data),
        });
    } catch (error) {
        console.error("Error while fetching dwh segments:", error);

        throw error;
    }
};

export const loadSettings = async () => {
    try {
        console.log("\n \t # Loading data setting :", getCMAccountList);
        return defer({
            data: Promise.all([getCMAccountList(), getCurrentUser()]),
        });
    } catch (error) {
        console.error(
            "Error while loading campaign creation required data:",
            error
        );

        throw error;
    }
}


// ============================ LOAD HLR OPERATIONS ============================
export const loadHlroperations = async () => {
    console.log("\n\n--- loadHlroperations ----")
    console.log("endpoint :", process.env
        .REACT_APP_API_GET_HLROPERATION_ENDPOINT as string)
    try {
        return defer({
            hlroperations: axiosInstance
                .get<HLROperationListItem[]>(
                    process.env.REACT_APP_API_GET_HLROPERATION_ENDPOINT as string
                )
                .then((response) => response.data),
        });
    } catch (error) {
        console.error("Error while fetching hlroperation:", error);

        throw error;
    }
};